/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The user types:
 *   * ADMIN : an administrator
 *   * OPERATOR : an operator
 *   * CLIENT : a client
 *   * PUBLIC : a public user
 */
export enum UserType {
  ADMIN = 'ADMIN',
  OPERATOR = 'OPERATOR',
  CLIENT = 'CLIENT',
  PUBLIC = 'PUBLIC'
}
